import { Controller } from "stimulus"

class CollapsableController extends Controller {
  toggle(e) {
    e.preventDefault();
    let { target } = e;
    target = target.closest('a,button');
    const collapsed = target.getAttribute('data-collapse-state') == 'true';
    const expandTargetId = target.getAttribute('data-expand-id');
    const expandIcons = target.parentNode.querySelectorAll('[data-hide-on-expand="true"]');
    const collapseIcons = target.parentNode.querySelectorAll('[data-hide-on-expand="false"]');
    if (collapsed) {
      // Turning from collapsed state to expanded state
      if (expandIcons.length > 0) {
        expandIcons.forEach(expandIcon => {
          expandIcon.classList.add('t-hidden');
        })
      }
      if (collapseIcons.length > 0) {
        collapseIcons.forEach(collapseIcon => {
          collapseIcon.classList.remove('t-hidden');
        })
      }
      this.element.querySelectorAll(`[data-collapse-id="${expandTargetId}"]`).forEach(el => el.classList.remove('t-hidden'))
    } else {
      if (expandIcons.length > 0) {
        expandIcons.forEach(expandIcon => {
          expandIcon.classList.remove('t-hidden');
        })
      }
      if (collapseIcons.length > 0) {
        collapseIcons.forEach(collapseIcon => {
          collapseIcon.classList.add('t-hidden');
        })
      }
      this.element.querySelectorAll(`[data-collapse-id="${expandTargetId}"]`).forEach(el => el.classList.add('t-hidden'))
    }
    target.setAttribute('data-collapse-state', `${!collapsed}`);
  }

  connect() {
  }
  initialize() {
    window.MConstants.d = '3';
  }
}

export default CollapsableController;
